import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch } from 'react-redux';
import { getDetailDriverTask, updateDriverTask } from 'features/drivers/actions';
import Modals from '../Modals';
import { Button, RadioButton } from 'components/Global';
import { ReactComponent as VehicleIcon } from 'icons/car-blue-bg.svg';
import { fetchOrderById, getOrderAddOnsById } from 'features/orders/actions';
import { fetchCustomerInfo } from 'features/user/actions';
import { trackEvent } from 'utils/analytics';

const CANCEL_REASON = [
  {
    id: 'cr1',
    label: 'Customer ada acara mendadak',
  },
  {
    id: 'cr2',
    label: 'Ingin membatalkan task saja',
  },
  {
    id: 'cr3',
    label: 'Ingin mengganti pesanan',
  },
  {
    id: 'cr4',
    label: 'Tidak dapat melanjutkan pesanan',
  },
  {
    id: 'cr5',
    label: 'Lainnya',
  },
];

const CancelTaskCharterModal = () => {
  const dispatch = useDispatch();
  // CONTEXT
  const { showToast, setShowCancelTaskCharter } = useAppContext();

  // GLOBAL STATE
  // const { selected: selectedData } = useSelector((state) => state.driverTaskList);

  // LOCAL STATE
  const [cancelReason, setCancelReason] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const key = searchParams.get('key');
  const customerId = searchParams.get('customer_id');

  const id = searchParams.get('id');

  // SUBMIT ACTION
  const handleSubmit = async () => {
    const payload = {
      id,
      // fee_per_task: selectedData?.fee_per_task,
      action: 'CANCELING_TASK',
      cancelation_reason: CANCEL_REASON.find((reason) => reason.id === cancelReason)?.label ?? '',
    };

    try {
      trackEvent('driver_task_updated', {
        task_id: id,
        source: 'cancel_task_charter_modal',
      });
      await dispatch(updateDriverTask(payload)).unwrap();
      setShowCancelTaskCharter(false);
      dispatch(fetchOrderById(key));

      if (customerId) {
        dispatch(fetchCustomerInfo(customerId));
      }

      if (id) {
        dispatch(getDetailDriverTask(id));
      }

      dispatch(getOrderAddOnsById(key));

      searchParams.delete('driver_id');
      setSearchParams(searchParams);

      showToast({ type: 'success', message: 'Berhasil cancel task' });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({ type: 'error', message: 'Gagal cancel task' });
    }
  };

  return (
    <Modals
      setState={setShowCancelTaskCharter}
      icon={<VehicleIcon fill="#009EF7" width="25px" height="25px" />}
      title={'Alasan Cancel Order'}
    >
      <div className="cancel-charter-task">
        <h1>Pilih Alasan Pembatalan</h1>

        <ul className="cancel-charter-task__reason">
          <RadioButton data={CANCEL_REASON} name="reason" state={cancelReason} setState={setCancelReason} />
        </ul>

        {/* BUTTON */}
        <div className="cancel-charter-task__button">
          <Button type="button" width={131} variant="outline" size="md" onClick={() => setShowCancelTaskCharter(false)}>
            Kembali
          </Button>
          <Button type="button" width={131} variant="primary" size="md" onClick={handleSubmit}>
            Kirim
          </Button>
        </div>
      </div>
    </Modals>
  );
};

export default CancelTaskCharterModal;
